import qs from 'qs';
import { useLocation } from 'react-router';

const defaultReferrer = '/';

export const useReferrer = () => {
  const location = useLocation();
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });

  const queryRedirectUrl = typeof query['redirect-url'] === 'string' ? query['redirect-url'] : undefined;

  try {
    const url = new URL(queryRedirectUrl ?? '');
    return url.origin === window.origin ? queryRedirectUrl : defaultReferrer;
  } catch {
    return defaultReferrer;
  }
};
